function createAccordionItem(el) {
  const accordionItem = document.createElement("div");
  accordionItem.classList = "accordion-item";

  accordionItem.innerHTML = `
  <button id="accordion-button-1" aria-expanded="false">
    <div class="accordion-title">${el.title}</div>
    <div class="accordion-icon">
    <span class="icon" aria-hidden="true"></span>
    </div>
  </button>

  <div class="accordion-content">
    <div class="p text-color--black faq--text">
    ${el.text}
    </div>
  </div>
`;
  return accordionItem;
}


function accordionBlock(src) {
  const accordionItems = document.querySelector(".accordion");

  getFaqItems(src);

  async function getFaqItems(src) {
    await fetch(src)
      .then((data) => data.json())
      .then((item) => {
        item.map((el) => accordionItems.append(createAccordionItem(el)));
      })
      .then(() => {
        const items = document.querySelectorAll(".accordion button");

        function toggleAccordion() {
          const itemToggle = this.getAttribute("aria-expanded");
          for (let i = 0; i < items.length; i++) {
            items[i].setAttribute("aria-expanded", "false");
          }

          if (itemToggle == "false") {
            this.setAttribute("aria-expanded", "true");
          }
        }

        items.forEach((item) =>
          item.addEventListener("click", toggleAccordion)
        );
      });
  }
  return accordionItems;
}


const srcAccordion = "/_data/faqUzbek.json";

accordionBlock(srcAccordion);
